import { VueModule } from '@Foundation/utilities';
import Banner from './code/Scripts/components/banner';

export default VueModule({
  components: {
    Banner
  }
});
